import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useGlobalActions } from '../../atoms';

export const LoginPage = () => {
    const navigate = useNavigate();
    const { userLogin } = useGlobalActions();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await userLogin(email, password);
            navigate('/');
        } catch (err: unknown) {
            if (err instanceof Response) {
                const text = await err.text();
                try {
                    const data = JSON.parse(text);
                    setError(data.message);
                } catch {
                    setError(text);
                }
            } else {
                setError('Network error. Please try again later.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F7F8F8] flex items-center justify-center p-4">
            <div className="w-full max-w-md bg-white rounded-lg shadow-md p-8">
                <div className="flex justify-center mb-4">
                    <img src="/logo.webp" alt="Fujiyama Logo" className="h-16" />
                </div>
                <h1 className="text-2xl font-bold text-center text-gray-800 mb-8">
                    Login
                </h1>

                {error && (
                    <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md text-sm">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                            Email Address
                        </label>
                        <input
                            id="email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="example@example.com"
                        />
                    </div>

                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                            Password
                        </label>
                        <input
                            id="password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="••••••••"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isLoading}
                        className={`w-full py-3 px-4 text-white rounded-md ${isLoading
                            ? 'bg-blue-400 cursor-not-allowed'
                            : 'bg-blue-600 hover:bg-blue-700'
                            } transition-colors duration-200`}
                    >
                        {isLoading ? 'Loading...' : 'Login'}
                    </button>
                </form>
                <div className="mt-4 text-center text-sm">
                    <span className="text-gray-600">Don't have an account?</span>{' '}
                    <Link to="/register" className="text-blue-600 hover:text-blue-700">
                        Register
                    </Link>
                </div>
                <div className="mt-2 text-center text-sm">
                    <Link to="/reset-password" className="text-blue-600 hover:text-blue-700">
                        Forgot Password?
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;